export enum MARKETS {
  UNITED_STATES = "US",
  DOMINICAN_REPUBLIC = "DO",
  CANADA = "CA",
  CHINA = "CN",
}

export enum MARKET_CODES {
  UNITED_STATES = "010",
  DOMINICAN_REPUBLIC = "580",
  CANADA = "020",
  AR = "380",
  AT = "210",
  AU = "030",
  BE = "120",
  BG = "620",
  BN = "780",
  BR = "310",
  BW = "750",
  CA = "020",
  CH = "110",
  CL = "400",
  CN = "360",
  CO = "190",
  CR = "290",
  CZ = "390",
  DE = "060",
  DK = "470",
  DO = "580",
  EE = "800",
  ES = "250",
  FI = "460",
  FR = "080",
  GB = "040",
  GR = "480",
  GT = "260",
  HK = "050",
  HN = "520",
  HR = "650",
  HT = "700",
  HU = "340",
  ID = "220",
  IE = "300",
  IN = "430",
  IT = "160",
  JP = "070",
  KR = "180",
  KZ = "830",
  LT = "810",
  LV = "820",
  MX = "170",
  MY = "100",
  NA = "740",
  NL = "090",
  NO = "280",
  NZ = "240",
  PA = "230",
  PH = "350",
  PL = "150",
  PT = "270",
  RO = "590",
  RU = "420",
  SE = "370",
  SG = "530",
  SI = "140",
  SK = "490",
  SV = "510",
  TH = "200",
  TR = "450",
  TW = "130",
  UA = "660",
  US = "010",
  UY = "440",
  VE = "600",
  VN = "500",
  ZA = "570",
  MN = "980",
  KG = "870",
  UZ = "940",
}
